"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationKeys = exports.defaultTranslationKeysWithNamespaces = exports.LogoutConfirmDialogTranslationKeys = void 0;
/** @deprecated LogoutConfirmDialog was moved to @ori-appshell/layouts, this will be removed in the next major release */
const LogoutConfirmDialogTranslationKeys = exports.LogoutConfirmDialogTranslationKeys = {};

/** @deprecated LogoutConfirmDialog was moved to @ori-appshell/layouts, this will be removed in the next major release */
const translationKeys = exports.translationKeys = {};

/** @deprecated LogoutConfirmDialog was moved to @ori-appshell/layouts, this will be removed in the next major release */
const defaultTranslationKeysWithNamespaces = exports.defaultTranslationKeysWithNamespaces = {};
